import * as React from 'react';
import { Translation } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { store } from 'helpers';
import { withRouter } from '../../../helpers/withRouter';
import { service } from 'services/service';
class EventTopNavBar extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            default_template_id: (this.props.event !== undefined ? this.props.event.default_template_id : null),
            event: this.props.event,
            checkin: { status: 1 },
            editUrl: false,        
            userinfo: [],
            modules: [],
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchModulesFromAPI();
        this.setState({ preLoader: true });
        const user = JSON.parse(localStorage.getItem('eventBuizz'));
        if (user && user.data && user.data.user) {
            this.setState({ userinfo: user.data.user.id });
        }
        service.get(`${process.env.REACT_APP_URL}/event-settings/module/alerts`)
            .then(
                response => {
                    if (response.success) {
                        if (this._isMounted) {
                            if (response.data) {
                                this.setState({
                                    checkin: response.data.module
                                });
                            }
                        }
                    }
                },
                error => { }
            );
    }
    async fetchModulesFromAPI() {
        try {
            const response = await service.post(`${process.env.REACT_APP_URL}/event-settings/modules`, { event_id: this.props.event.id });
            console.log(response.data.modules,'hereeee');
            if (response.success && response.data && response.data.modules) {
                if (this._isMounted) {
                    this.setState({ modules: response.data.modules });
                }
            }
        } catch (e) {
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.event?.id !== undefined && state.event?.id !== props.event.id) {
            return {
                event: props.event,
                default_template_id: (props.event !== undefined ? props.event.default_template_id : null),
                modules: [],
            };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.event?.id !== this.props.event?.id && this.props.event?.id) {
            this.fetchModulesFromAPI();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    getEditBadges() {
        const organizerId = this.state.userinfo;
        if (!organizerId) {
            console.error("No user ID available");
            return;
        }
        return service.eventCenterAutoLogin(`${process.env.REACT_APP_EVENTCENTER_URL}/_admin/badges/redirectAfterLogin/${organizerId}`)
          .then(
            response => {
              if (response.success && response.link) {
                if (this._isMounted) {
                  this.setState({ editUrl: response.link });
                }
                return response.link;
              }
            },
            error => { }
          );
      }

    render() {
        return (
            <Translation>
                {t => (
                    <div className="col-9">
                        <nav className="dashboard-nav">
                            <ul>
                                <li>
                                    <NavLink to={`/event/template/edit/${this.state.default_template_id}`}>
                                        <ReactSVG title={t('M_TEMAPLETS')} alt={t('M_TEMAPLETS')} wrapper="span" className="icons" src={require('img/icon-templates.svg')} />
                                        {t('M_TEMAPLETS')}
                                    </NavLink>
                                </li>
                                <li>
                                    <a href='#!' className={window.location.pathname.includes('/event/invitation/send-invitation') ? 'active' : ''} onClick={() => { store.dispatch({ type: "invitation", invitation: null }); this.props.history.push('/event/invitation/send-invitation'); }}>
                                        <ReactSVG title={t('M_SEND_INVITE')} alt={t('M_SEND_INVITE')} wrapper="span" className="icons" src={require('img/icon-sendinvite.svg')} />
                                        {t('M_SEND_INVITE')}
                                    </a>
                                </li>
                                <li>
                                    <NavLink to={`/event/reports`}>
                                        <ReactSVG title={t('M_REPORTS')} alt={t('M_REPORTS')} wrapper="span" className="icons" src={require('img/icon-reports.svg')} />
                                        {t('M_REPORTS')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={`/dashboard`}>
                                        <ReactSVG title={t('M_ANALYTICS')} alt={t('M_ANALYTICS')} wrapper="span" className="icons" src={require('img/icon-analytics.svg')} />
                                        {t('M_ANALYTICS')}
                                    </NavLink>
                                </li>
                                <li style={{ display: this.state.checkin && Number(this.state.checkin.status) === 0 ? 'none' : 'fill' }}>
                                    <NavLink to={`/event_site/billing-module/manage-orders`}>
                                        <ReactSVG title={t('M_ORDERS')} alt={t('M_ORDERS')} wrapper="span" className="icons" src={require('img/icon-order.svg')} />
                                       {t('M_ORDERS')}
                                    </NavLink>
                                </li>
                                {this.state.modules && this.state.modules
                                    .filter((module) => module.alias === "attendees")
                                    .map((module) => (
                                        <li key={module.id} style={{ pointerEvents: Number(module.status) === 0 ? "none" : "fill" }}>
                                            <NavLink to={`/event/module/attendees`}>
                                                <ReactSVG title={t('M_REGISTRATIONS')} alt={t('M_REGISTRATIONS')} wrapper="span" className="icons" src={require('img/icon-attendee.svg')} />
                                                {t('M_REGISTRATIONS')}
                                            </NavLink>
                                        </li>
                                    ))
                                }
                                <li style={{ pointerEvents: this.state.checkin && Number(this.state.checkin.status) === 0 ? 'none' : 'fill' }}>
                                    <NavLink to={`/event/news/alerts`}>
                                        <ReactSVG title={t('M_SEND_NEWS')} alt={t('M_SEND_NEWS')} wrapper="span" className="icons" src={require('img/icon-sendnews.svg')} />
                                        {t('M_SEND_NEWS')}
                                    </NavLink>
                                </li>
                                <li style={{ display: this.state.checkin && Number(this.state.checkin.status) === 0 ? 'none' : 'fill' }}>
                                    <a href={this.state.editUrl || '#'} target="_blank" rel="noopener noreferrer" onClick={async (e) => {
                                        if (!this.state.editUrl) {
                                            e.preventDefault();
                                            const url = await this.getEditBadges();
                                            if (url) {
                                            window.open(url, '_blank', 'noopener,noreferrer');
                                            }
                                        }}}>
                                            <ReactSVG title={t('BADGES_DESIGN')} alt={t('BADGES_DESIGN')} wrapper="span" className="icons" src={require('img/badge_icon.svg')} />
                                        {t('BADGES_DESIGN')}
                                    </a>
                                    </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </Translation>
        );
    }
};

function mapStateToProps(state) {
    const { event } = state;
    return {
        event
    };
}

export default connect(mapStateToProps)(withRouter(EventTopNavBar));

